import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { getStandings } from './puzzleApi';
import './CaseFile.css';

const fontsUrl = 'https://fonts.googleapis.com/css2?family=Special+Elite&family=Libre+Franklin:ital,wght@0,400;0,600;0,800;1,400&display=swap';

const TABS = [
  { key: 'wins', label: 'Wins' },
  { key: 'points', label: 'Total Points' },
  { key: 'ppg', label: 'PPG' },
  { key: 'streak', label: 'Streak' }
];

const COLUMN_LABEL = { wins: 'Wins', points: 'Points', ppg: 'PPG', streak: 'Streak' };

const Standings = () => {
  const [sort, setSort] = useState('wins');
  const [state, setState] = useState({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;

    setState({ status: 'loading' });

    getStandings(sort)
      .then((data) => {
        if (!cancelled) {
          setState({ status: 'ready', data });
        }
      })
      .catch((error) => {
        if (!cancelled) {
          setState({ status: 'error', code: error.code || 'server_error' });
        }
      });

    return () => {
      cancelled = true;
    };
  }, [sort]);

  return (
    <div className="case-file-page">
      <Helmet>
        <title>Standings | Jerry Evanoff</title>
        <meta name="description" content="See who's topping the leaderboard on Jerry Evanoff's weekly Sam Norris mystery puzzle." />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link rel="stylesheet" href={fontsUrl} />
      </Helmet>

      <main className="cf-folder">
        <span className="cf-tab">LEADERBOARD</span>
        <h1>Standings</h1>
        <p className="cf-series-note">Everyone's welcome on one board or another — pick your category.</p>

        <div className="cf-standings-tabs">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              type="button"
              className={`cf-standings-tab ${sort === tab.key ? 'active' : ''}`}
              onClick={() => setSort(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {state.status === 'loading' && <p className="cf-brief">Loading…</p>}
        {state.status === 'error' && <p className="cf-error" role="alert">Couldn't load the standings. Please try again.</p>}

        {state.status === 'ready' && (
          <>
            {sort === 'ppg' && (
              <p className="cf-fineprint">Needs at least {state.data.minGamesForPpg} games played to appear.</p>
            )}

            {state.data.rows.length === 0 ? (
              <p className="cf-brief">Nobody's qualified for this board yet. Be the first, detective.</p>
            ) : (
              <ol className="cf-standings-list">
                {state.data.rows.map((row, index) => (
                  <li key={row.nickname} className={`cf-standings-row ${state.data.viewer && state.data.viewer.nickname === row.nickname ? 'you' : ''}`}>
                    <span className="cf-standings-position">{index + 1}</span>
                    <span className="cf-standings-nickname">{row.nickname}</span>
                    <span className="cf-standings-rank">{row.rank.name}</span>
                    <span className="cf-standings-value">{row[sort]}{sort === 'ppg' ? '' : ` ${COLUMN_LABEL[sort].toLowerCase()}`}</span>
                  </li>
                ))}
              </ol>
            )}

            {state.data.viewer && !state.data.rows.some((row) => row.nickname === state.data.viewer.nickname) && (
              <div className="cf-standings-viewer">
                <span className="cf-standings-position">{state.data.viewer.position}</span>
                <span className="cf-standings-nickname">{state.data.viewer.nickname} (you)</span>
                <span className="cf-standings-rank">{state.data.viewer.rank.name}</span>
                <span className="cf-standings-value">{state.data.viewer[sort]}</span>
              </div>
            )}
          </>
        )}

        <p className="cf-back-links">
          <Link to="/case-file">This week's case</Link> · <Link to="/my-record">Your full record</Link>
        </p>
      </main>
    </div>
  );
};

export default Standings;
